import React, { CSSProperties, useContext } from "react";
import { Link } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { AdminPaths, PublicPaths } from "Views/Paths";
import { UserContext } from "Views/UserProvider";
import {
  LoggedInHeaderHamburger,
  logOutAndRedirect,
} from "./LoggedInHeaderHamburger";

export function LogoImg(props: { style?: CSSProperties }) {
  return (
    <img
      alt={`${serverConstants.CompanyName} Logo`}
      src="/img/Logos/levelesq-logo-color-01.svg"
      style={{
        backgroundColor: "white",
        height: 80,
        ...props.style,
      }}
    />
  );
}

export function MainHeader() {
  const { user } = useContext(UserContext);

  if (user && !user.isActive) {
    void logOutAndRedirect();
  }

  return (
    <header
      id="header"
      className="has-background-white"
      style={{ padding: "1em" }}
    >
      <nav className="level is-mobile">
        <div className="level-item is-pulled-left">
          {user ? (
            <Link to={AdminPaths.AdminDashboard}>
              <LogoImg />
            </Link>
          ) : (
            <LogoImg />
          )}
        </div>
        <div className="level-item is-pulled-right">
          {user ? (
            <LoggedInHeaderHamburger currentUser={user} />
          ) : (
            <LoginLink />
          )}
        </div>
      </nav>
    </header>
  );
}

function LoginLink() {
  return (
    <Link to={PublicPaths.LogIn} className="level-item is-primary">
      Log In
    </Link>
  );
}
